module.exports = __webpack_public_path__ + "static/media/Portrait-10014_original_24112021.db328c92.jpg";